<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Order Applications</template>
        </page-header>

        <div class="px-6 pt-2">
            <div class="flex justify-start mt-2 flex-wrap">
                <div class="relative pr-4 mb-3 w-1/2">
                    <label class="block w-full text-sm pb-1">Applications
                        <span><font-awesome-icon class="text-sm text-sm ml-2" style="top: 12px; cursor: pointer;" tooltip="Sort By Name" :icon="['fas', 'sort-up']" v-on:click="onAscending" /></span>
                        <span><font-awesome-icon class="text-sm text-sm ml-2" style="top: 12px; cursor: pointer;" tooltip="Reset" :icon="['fas', 'undo']" v-on:click="onReset" /></span>
                    </label>
                    <ul class="list-group list-reset">
                        <draggable :list="applications">
                            <li v-for="(application, index) in applications"
                                v-bind:key="index"
                                class="cursor-move border border-gray-500 py-1 px-2 mb-2 bg-gray-200 text-sm"
                                draggable="true"
                                v-on:dragstart="dragstart(application, $event)"
                                v-on:dragend="dragend($event)"
                            >
                                <div class="relative pr-4 mb-3 inline">{{ application.name }}</div>
                                <div class="relative pr-4 mb-3 float-right">({{ application.ordering ? application.ordering : 'N/A' }})</div>
                            </li>
                        </draggable>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import draggable from 'vuedraggable';

export default {
    name: 'ApplicationOrdering',
    components: {
        draggable
    },
    data: function(){
        return {
            pageActions: {
                buttons: [
                    {
                        label: 'Cancel',
                        icon: 'times',
                        iconClass: 'text-red-600',
                        type: 'method',
                        method: 'cancel'
                    },
                    {
                        label: 'Apply',
                        icon: 'check',
                        iconClass: 'text-green-600',
                        type: 'method',
                        method: 'apply'
                    }
                ]
            },
            applications: [],
            dragging: false
        }
    },
    beforeMount() {
        this.getData();
    },
    mounted() {
        this.$Progress.finish();
    },
    methods: {
        getData: function(){
            axios.get(process.env.VUE_APP_API_URL + '/application-forms?sortColumn=ordering&sortDir=ASC')
                .then(response => {
                    this.applications = response.data.map(function(application) {
                        return {
                            id: application.id,
                            name: application.name,
                            ordering: application.ordering
                        };
                    });
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$Progress.finish();
                });
        },
        methodHandler: function(method){
            this[method]();
        },
        dragstart: function(item, e) {
            this.$emit('redrag', item);
            e.target.style.opacity = 0.5;
        },
        dragend: function(e) {
            e.target.style.opacity = 1;
            this.setOrder();
        },
        onAscending: function() {
            this.applications.sort(function (a, b) {
                if (a.name < b.name) return -1;
                if (b.name < a.name) return 1;
                return 0;
            });
            this.setOrder();
        },
        onReset: function(){
            this.getData();
        },
        setOrder: function(){
            this.applications.forEach((t, index) => {
                t.ordering = (index + 1);
            });

        },
        cancel: function(){
            this.$router.push('/application-forms');
        },
        apply: function(){
            this.$store.commit('TOGGLE_BACKDROP', { open: true });

            if(this.applications.some(application => application.ordering === 0)){
                this.$notify({
                    group: 'main',
                    position: 'bottom right',
                    type: 'error',
                    title: 'Warning',
                    text: 'Object(s) has no order',
                    duration: 5000
                });

                this.$store.commit('TOGGLE_BACKDROP', { open: false });
                return;
            }

            axios.post(process.env.VUE_APP_API_URL + '/ordering', {
                orderingType: 'applications',
                orderingData: this.applications
            }).then(response => {
                this.$store.commit('TOGGLE_BACKDROP', { open: false });

                if (response.data.success){
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'success',
                        title: 'Success',
                        text: response.data.message,
                        duration: 5000
                    });
                }
            }).catch(() => {
                this.$store.commit('TOGGLE_BACKDROP', { open: false });
            });
        }
    }
}
</script>
